export default __webpack_public_path__ + "static/media/zemepis.b074b00c.svg";